import moment from 'moment';
import 'moment-timezone';

export const datetimeMixin = {
  computed: {
    todayUtc() {
      return moment.utc().format();
    },

    userTimezone() {
      return moment.tz.guess();
    },

    cityTimezone() {
      return this.userTimezone.substr(this.userTimezone.indexOf('/') + 1);
    }
  },

  methods: {
    timeWithTimeZone(time) {
      return moment(time).tz(this.userTimezone).format();
    },

    /**
     * Get now date-time
     *
     * @param {String} format only ["format", "toISOString"]
     * @return {String} date time with new format
     */
    today(format) {
      return moment()[format]();
    },

    formatedComparableToday() {
      return moment().tz(this.userTimezone).format('M/D/YYYY h:mm:ss A');
    },

    formatedComparable(date) {
      return moment(date).tz(this.userTimezone).format('M/D/YYYY h:mm:ss A');
    },

    formatedDatetime(date, format) {
      return moment(date).tz(this.userTimezone).format(format);
    },

    formatDateTimeDefault(dateTime) {
      return `${this.formatedDatetime(dateTime, 'MMM D, YYYY hh:mma')} ${this.cityTimezone}`;
    },

    formatedDatetimeWithTimezone(date, format) {
      const m = moment(date).tz(this.userTimezone);

      return {
        text: m.format(format),
        tz: m.tz()
      };
    },

    hours12(time) {
      return moment(time, 'hh:mm:ss.sss').format('hh:mma');
    },

    formatedComparableDatetime(date) {
      return this.formatedDatetime(date, 'M/D/YYYY h:mm:ss A');
    },

    /**
     * format datetime for message pattern
     *  - < 1 day: show time ex: "11:01 AM"
     *  - > 1 & < 2 days: show "Yesterday"
     *  - > 2 & < 7 days: show name of day ex: "Wednesday"
     *  - > 7 days: show full date: ex: "Feb 2, 2021"
     * @param {Date} dateTime
     * @return {String} formatted date
     */
    formatMessageDatetime(dateTime) {
      // const todayDate = moment();
      // const compareDate = moment(dateTime);
      // const diffHour = todayDate.diff(compareDate, "hours");
      // if (diffHour < 24) {
      //   return compareDate.format("hh:mm A");
      // } else if (diffHour < 48) {
      //   return "Yesterday";
      // } else if (diffHour < 168) {
      //   return compareDate.format("dddd");
      // } else {
      //   return compareDate.format("MMM D, YYYY");
      // }
      return moment(dateTime).format('MMM D, YYYY hh:mma');
    },

    /**
     * Check date is between
     * format => MMMM D YYYY HH:mm A
     * @param {String} compared
     * @param {String} start
     * @param {String} end
     * @return {Boolean} true => if compared date between start and end
     */
    isBetween(compared, start, end) {
      return moment(new Date(this.formatedDatetime(compared, 'LLL'))).isBetween(
        moment(new Date(this.formatedDatetime(start, 'LLL'))),
        moment(new Date(this.formatedDatetime(end, 'LLL'))),
        undefined,
        '[]'
      );
    },

    /**
     * Loop and push data to generate time in options.
     *
     * @param {Number} init first index for start loop
     * @param {Number} final last index for end loop
     * @return {String[]}
     */
    generateTime(init = 0, final = 48) {
      const time = [];
      for (let i = init; i < final; i++) {
        const intHour = Math.floor(i / 2);
        const hour = `${i / 2 < 10 ? `0${intHour}` : intHour}`;
        if (i % 2 === 0) {
          time.push(`${hour}:00`);
        }
        if (i % 2 !== 0) {
          time.push(`${hour}:30`);
        }
      }
      return time;
    },

    generateNumber(init = 0, final = 48) {
      const time = [];
      for (let i = init; i < final; i++) {
        const intHour = Math.floor(i / 2);
        const hour = `${i / 2 < 10 ? `0${intHour}` : intHour}`;
        if (i % 2 === 0) {
          time.push(`${hour}`);
        }
      }

      return time; // return array[string]
    },

    sortDateArray(dates, order = 'asc') {
      function compare(a, b) {
        const date1 = new Date(a);
        const date2 = new Date(b);

        return order === 'asc' ? date1 - date2 : date2 - date1;
      }

      dates.sort(compare);

      return dates;
    },

    sortDateCollection(array, field, order = 'asc') {
      function compare(a, b) {
        const date1 = new Date(a[field]);
        const date2 = new Date(b[field]);

        return order === 'asc' ? date1 - date2 : date2 - date1;
      }

      array.sort(compare);

      return array;
    },

    convertHMS(value) {
      const sec = parseInt(value, 10); // convert value to number if it's string
      let hours = Math.floor(sec / 3600); // get hours
      let minutes = Math.floor((sec - hours * 3600) / 60); // get minutes
      let seconds = sec - hours * 3600 - minutes * 60; //  get seconds
      // add 0 if value < 10; Example: 2 => 02
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (seconds < 10) {
        seconds = '0' + seconds;
      }

      return hours + ':' + minutes + ':' + seconds; // Return is HH : MM : SS
    },

    $_datetimeMixin_convertUTC(date) {
      return Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
      );
    },

    $_datetimeMixin_isGreaterThanNow(comparedDate) {
      const comparedUTC = this.$_datetimeMixin_convertUTC(comparedDate);
      const nowUTC = this.$_datetimeMixin_convertUTC(new Date());

      return comparedUTC > nowUTC;
    },

    $_datetimeMixin_isLessThanNow(comparedDate) {
      const comparedUTC = this.$_datetimeMixin_convertUTC(comparedDate);
      const nowUTC = this.$_datetimeMixin_convertUTC(new Date());

      return comparedUTC < nowUTC;
    },

    formatDynamicDateTime(date) {
      let currentDate = new Date();
      let dif = currentDate - date;

      let min = 1000 * 60;
      let hour = 1000 * 60 * 60;
      let day = 1000 * 60 * 60 * 24;
      let week = 1000 * 60 * 60 * 24 * 7;

      if (dif < min) {
        return 'Just Now';
      }

      if (dif < hour) {
        return `${Math.floor(dif / min)} min. ago`;
      }

      if (dif < day) {
        return `${Math.floor(dif / hour)} hr. ago`;
      }

      if (dif < week) {
        const numDays = Math.floor(dif / day);

        return `${numDays} day${numDays > 1 ? 's' : ''} ago`;
      }

      return moment(date).format('MMM D, YYYY');
    }
  }
};
